import Vue from 'vue'
import {CONFIG} from './config.js';

const List = Vue.component('list', {
    data: function() {
        return {
            'searchTerm': null,
        }
    },
    mounted: function() {
        this.$loadShifts();
    },
    computed: {
        shifts () {
            return this.$store.state.shifts;
        }
    },
    template: '#list'
})

export default List;